var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCMakeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.356 129.131L36.5443 214.459L127.963 31.793L136.356 129.131Z",
    fill: "url(#paint0_linear_404_260)",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.981 182.419L128.01 31.7764L219.545 214.476L140.981 182.419Z",
    fill: "url(#paint1_linear_404_260)",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8176 163.548L219.639 214.454L36.5681 214.434L95.8176 163.548Z",
    fill: "url(#paint2_linear_404_260)",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0059 163.671L136.293 129.303L141.902 182.378L96.0059 163.671V163.671Z",
    fill: "url(#paint3_linear_404_260)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_404_260",
    x1: 78.9132,
    y1: 164.733,
    x2: 123.642,
    y2: 70.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1011A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6969E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_404_260",
    x1: 139.124,
    y1: 93.0525,
    x2: 201.629,
    y2: 198.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B40E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_404_260",
    x1: 164.929,
    y1: 206.021,
    x2: 76.6192,
    y2: 198.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_404_260",
    x1: 133.963,
    y1: 173.335,
    x2: 132.816,
    y2: 134.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCMakeDark);
export default __webpack_public_path__ + "static/media/CMake-Dark.91260b3eaac7ed30afddccd6c23bd41a.svg";
export { ForwardRef as ReactComponent };